import { Send } from 'lucide-react';

const TELEGRAM_HANDLE = 'CADPartner';

const TelegramButton = () => {
  const url = `https://t.me/${TELEGRAM_HANDLE}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="telegram-float group"
      data-testid="telegram-chat-button"
      aria-label="Chat on Telegram"
    >
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white">
        <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.022c.243-.213-.054-.334-.373-.121l-6.871 4.326-2.96-.924c-.643-.204-.658-.643.135-.953l11.566-4.458c.535-.196 1.006.128.832.938z"/>
      </svg>
      <span className="telegram-tooltip">Chat on Telegram</span>
    </a>
  );
};

export default TelegramButton;
